/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactElement, useEffect, useRef, useState } from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';
import { DeviceType, Group, ParametersType } from '../constants/telosair-interfaces';
import DetailedFloor from './DetailedFloor';
import GroupMap from './MapGroup';

type ContorProps = {
  group: Group;
  selectedParameters: ParametersType[];
};

/**
 * React component for Contor.
 * @param props - Properties of Contor component.
 * @returns - React component for Contor.
 */
export default function Contor(props: ContorProps): ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { group, selectedParameters } = props;
  const ParentDivRef = useRef<HTMLDivElement>(null);
  const [resized, setResized] = useState(false);

  useEffect(() => {
    if (resized) {
      setResized(false);
    }
  }, [resized]);

  return (
    <div ref={ParentDivRef} className="relative h-full ">
      {group.floorPlan === DeviceType.OUTDOOR ? (
        <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''}>
          <GroupMap selectedParameters={selectedParameters} selectedGroup={group} />
        </APIProvider>
      ) : (
        <DetailedFloor
          selectedParameters={selectedParameters}
          showExpandedView={false}
          selectedGroup={group}
        />
      )}
    </div>
  );
}
